function isNumeric(value) {
    return /^[0-9]+$/.test(value);
}

export { isNumeric };
